import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Tooltip from '../../../../../../components/Tooltip';

// eslint-disable-next-line react/prop-types
const Handle = () => (
  <div className="menu-list__element-handle">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 20">
      <path d="M7 2c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm0 6c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm0 6c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm6-8c1.104 0 2-.896 2-2s-.896-2-2-2-2 .896-2 2 .896 2 2 2zm0 2c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm0 6c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2z" />
    </svg>
  </div>
)

const SortableMenuElement = (props) => {
  const { title, icon, tooltip, default_language, onOpenModal } = props;
  return (
    <div className="menu-list__element">
      <div>
        {icon ? (
          <div className="menu-list__element-icon">
            <i className={icon} />
          </div>
        ) : <Handle /> }
        <div className="menu-list__element-title">
          {title[default_language]}
          {tooltip
            ? (
              <Tooltip placement="right" text={tooltip} tooltipClass="tooltip__right">
                <span className="fas fa-info-circle menu-list__element-help" />
              </Tooltip>
            ) : null}
        </div>
      </div>
      <div className="menu-list__element-action">
        <Button bsSize="xsmall" onClick={() => onOpenModal('edit_menu', props)}>Edit</Button>
      </div>
    </div>
  )
};

SortableMenuElement.propTypes = {
  default_language: PropTypes.string,
  onOpenModal: PropTypes.func,
  title: PropTypes.string,
  icon: PropTypes.string,
  tooltip: PropTypes.string,
};
export default SortableElement(SortableMenuElement)
